import React from 'react';

/**
 * Runs a function only once during a components lifetime.
 * Equivalent to componentDidMount.
 */
export default (runOnceFunction) => {
    React.useEffect(() => { runOnceFunction() } , []);
}